import React from 'react';
import BlastResults from '../blast_sms/BlastResults';

function EmailNewsletterResults() {
    return (
        <BlastResults
            listPath="/newsletter/email"
            listLabel="Past Email Newsletter"
            channelLabel="Email Newsletter"
            icon="bi-envelope-paper"
        />
    );
}

export default EmailNewsletterResults;
